module.exports = __webpack_public_path__ + "static/media/home_bg.3dd4dc48.jpg";